import { Component, ChangeDetectionStrategy, AfterViewInit, OnDestroy, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppSettings } from './app.settings';
import { Router, NavigationEnd } from '@angular/router';
import { AppService } from './app.service';
import { AppConfig } from './app.config';
import { AuthenticationService } from './services/AuthenticationService';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { LoggingService } from './services/LoggingService';


@Component({ standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit, OnDestroy {

  private destroyRef = inject(DestroyRef);

  constructor(private appSettings:AppSettings, public router:Router, private appService:AppService, private appConfig:AppConfig, private authService:AuthenticationService, private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer, private logger:LoggingService){
    //add some custom icons
    this.matIconRegistry.addSvgIcon('linkedin-icon',this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/linkedin-icon.svg"));
    this.matIconRegistry.addSvgIcon('x-icon',this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/x-icon.svg"));
    //first we need to verify if we already have required data in session storage to init the app coming from a refresh
    this.appService.init();
    //now we need to add event listener for local storage events to achieve session data sharing between browser tabs
    window.addEventListener('storage', this.onStorageEvent);
    window.localStorage.setItem('REQUESTING_SHARED_CREDENTIALS', Date.now().toString())
    window.localStorage.removeItem('REQUESTING_SHARED_CREDENTIALS')
  }

  private readonly onStorageEvent = (event: StorageEvent): void => {
      var jsonUser=sessionStorage.getItem('currentUser');
      var accessToken=this.appConfig.accessToken;
      var businessId=this.appConfig.businessId;
      var credentials:{u:string,at:string,bId:string}|undefined=undefined;
      if(jsonUser&&accessToken&&businessId) credentials={u:jsonUser,at:accessToken,bId:businessId};
      if(event.key === 'REQUESTING_SHARED_CREDENTIALS' && event.newValue!=undefined){
          this.logger.log('Requesting shared credentials')
          window.localStorage.setItem('CREDENTIALS_SHARING', JSON.stringify(credentials))
          window.localStorage.removeItem('CREDENTIALS_SHARING')
      }
      if(event.key === 'CREDENTIALS_SHARING' && !credentials && event.newValue){
        const newValue=event.newValue;
        if(newValue){
          //set in session storage if not already existing
          let parsed:{u:string,at:string,bId:string}|undefined;
          try {
            parsed = JSON.parse(newValue);
          } catch {
            parsed = undefined;
          }
          if(parsed){
            credentials=parsed;
            window.sessionStorage.setItem('currentUser', parsed.u);
            this.appConfig.accessToken=parsed.at;
            this.appConfig.businessId=parsed.bId;
          }
        }
      }
      if(event.key === 'CREDENTIALS_FLUSH' && event.newValue!=undefined && credentials && event.newValue===this.authService.currentUserValue?.userName){
        this.authService.logout();
      }
  };

  ngAfterViewInit(){
    this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(event => {
      if (event instanceof NavigationEnd) {
        setTimeout(() => {
          window.scrollTo(0,0);
        });
      }
    });
  }

  ngOnDestroy(){
    window.removeEventListener('storage', this.onStorageEvent);
  }

  get settings(){
    return this.appSettings.settings;  
  }

  get maintenanceMode(){
    return this.appConfig.maintenanceMode;
  }
}
